import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSnack } from "../../../hooks/useSnack";
import classroomServices from "../../../services/classroomServices";
import Button from "../../Button";
import Modal from "../../Modal";

const ConfirmFinishLessonsModal = forwardRef(({ onSubmit }, ref) => {
  const { t } = useTranslation();
  const { showSnack } = useSnack();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLessons, setSelectedLessons] = useState(null);
  const [classroom, setClassroom] = useState(null);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false); // <-- loading state

  useImperativeHandle(ref, () => ({
    openModal(classroom, lesson, students) {
      setClassroom(classroom);
      setSelectedLessons(lesson);
      setStudents(students);

      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setSelectedLessons(null);
    setIsOpen(false);
    setLoading(false); // Reset loading in case modal is closed mid-process
  };

  const handleFinishLesson = async () => {
    setLoading(true); // <-- start loading
    try {
      const lessonIds = selectedLessons?.map((lesson) => lesson.lesson_id || lesson.lesson.id);
      const studentsIds = students?.map((item) => item.student.id);

      const payload = {
        lesson_id: lessonIds,
        classroom_id: classroom?.id,
        students: studentsIds,
      };

      const response = await classroomServices.finishLesson(payload);
      showSnack(response.message, "success");
      onSubmit();
    } catch (error) {
      showSnack(error, "error");
    } finally {
      setLoading(false); // <-- end loading
      handleCloseModal();
    }
  };

  return (
    <Modal
      footer={
        <div className="flex items-center justify-end space-x-2">
          <Button
            color="white"
            variant="outlined"
            onClick={handleCloseModal}
            label={t("cancel")}
            className="w-28"
            disabled={loading}
          />
          <Button
            label={t("yes_sure")}
            onClick={handleFinishLesson}
            className="w-28"
            disabled={loading}
            loading={loading}
          />
        </div>
      }
      isOpen={isOpen}
      onClose={handleCloseModal}
      className="w-full max-w-md text-center"
    >
      <p className="mt-4 text-lg">{t("are_you_sure_finish")}</p>
    </Modal>
  );
});

export default ConfirmFinishLessonsModal;
